module.exports = __webpack_public_path__ + "static/media/Ms-Jollie-Regular.6610d2ee.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Ms-Jollie-Regular.woff2
// module id = 2323
// module chunks = 43